import React from "react";

export const authEN: AuthResourcesInterface = {
  title: "Some Title",
  aboutMeDescription: () => <React.Fragment>Some Element</React.Fragment>,
  registerButton: "Register",
  errors: {
    loginError:
      "An error occurred during login. Please check if your email and password are correct. If the problem persists, contact the administrator.",
    register:
      "Account creation failed. The email you entered was already registered or there was another issue. Please contact the administrator.",
    registerPic: "The picture you are uploading is too large.",
    emailNotFound: "Your account was not found",
    emailFound:
      "Please check your email and enter the one-time password you received.",
    errorPsw:
      "There has been an error updating your password. Please contact the administrator.",
    errorCaptcha:
      "An error occurred during verification. Please reload the page. If the error persists, contact the administrator.",
  },
  login: {
    title:
      "Enter your email address and password to access the evidence system",
    email: "Email",
    emailError: "Please enter a valid email address",
    passwordError: "Please enter a valid password",
    password: "Password",
    button: "Access",
    emailPlaceholder: "Enter email address",
    passwordPlaceholder: "Enter password",
    bottom: {
      forgot: "Forgot your password?",
      signup: "Sign up",
      donthave: "Don't have an account?",
    },
  },
  confirm: {
    title: "Success!",
    email: "Email has been sent to ",
    checkEmail:
      ". Please check the email you received and click on the link within the message to reset your password.",
    back: "Back to login",
  },
  forgetPassword: {
    modal: {
      title: "Success",
      text: "You have successfully changed your data.",
      button: "Done",
    },
    checkTempButton: "Save new password",
    email: {
      label: "Email",
      name: "email",
      error: "Enter a valid email",
      validation: "Invalid email",
      placeholder: "Enter a valid email",
    },
    tempPassword: {
      label: "One-time password",
      name: "tempPassword",
      error: "Please enter your one-time password.",
      placeholder: "Enter your one-time password.",
    },
    password: {
      label: "Password",
      name: "password",
      error: "Enter a valid password",
      validation: "Invalid password",
    },
    passwordRepeat: {
      label: "Repeat password",
      name: "repeatPassword",
      error: "Please repeat password entry",
      validation: "Invalid password",
      matchError: "Your password is incorrect",
    },
    title:
      "Enter your email address to which we will send instructions for changing your password.",
    changeButton: "Reset password",
    findButton: "Find user",
    login: {
      description: "Remember your password?",
      button: "Sign in!",
    },
    register: {
      description: "Don't have an account?",
      button: "Sign up!",
    },
  },
  logout: {
    back: "Back to",
    backButton: "Login",
    title: "See you again!",
    description: "You have successfully logged out!",
  },
};

interface FieldValidation {
  label: string;
  name: string;
  error: string;
  validation?: string;
  placeholder?: string;
  matchError?: string;
}

interface Modal {
  title: string;
  text: string;
  button: string;
}

interface ForgetPassword {
  title: string;
  email: FieldValidation;
  password: FieldValidation;
  passwordRepeat: FieldValidation;
  tempPassword: FieldValidation;
  findButton: string;
  checkTempButton: string;
  changeButton: string;
  login: {
    description: string;
    button: string;
  };
  register: {
    description: string;
    button: string;
  };
  modal: Modal;
}

interface ErrorFields {
  loginError: string;
  register: string;
  registerPic: string;
  emailNotFound: string;
  emailFound: string;
  errorPsw: string;
  errorCaptcha: string;
}

export interface AuthResourcesInterface {
  title: string;
  aboutMeDescription: () => JSX.Element;
  registerButton: string;
  login: {
    title: string;
    email: string;
    password: string;
    emailError: string;
    emailPlaceholder: string;
    passwordError: string;
    passwordPlaceholder: string;
    button: string;
    bottom: {
      forgot: string;
      signup: string;
      donthave: string;
    };
  };
  confirm: {
    title: string;
    email: string;
    checkEmail: string;
    back: string;
  };
  forgetPassword: ForgetPassword;
  logout: {
    back: string;
    backButton: string;
    title: string;
    description: string;
  };
  errors: ErrorFields;
}
